module.exports.normalizeTitle = (title) => {
	return title.toLowerCase().replace(/ /gi, "");
};
